import React from "react";
import { Modal, ScrollView, Text, View } from "react-native";
import { useRsvpColors } from "../theme";
import RsvpPrimaryButton from "./RsvpPrimaryButton";

interface Props {
  visible: boolean;
  title: string;
  body: string;
  onClose: () => void;
}

/** Tenant-themed popup showing a full agreement/policy body. */
const RsvpPolicyModal: React.FC<Props> = ({ visible, title, body, onClose }) => {
  const colors = useRsvpColors();

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={onClose}
    >
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(0,0,0,0.5)",
          alignItems: "center",
          justifyContent: "center",
          padding: 16,
        }}
      >
        <View
          style={{
            width: "100%",
            maxWidth: 448,
            maxHeight: "80%",
            backgroundColor: colors.background,
            borderWidth: 1,
            borderColor: colors.cardBorder,
            borderRadius: 16,
            padding: 24,
          }}
        >
          <Text
            style={{
              color: colors.textPrimary,
              fontSize: 18,
              fontWeight: "700",
              marginBottom: 12,
            }}
          >
            {title}
          </Text>
          <ScrollView style={{ flexGrow: 0 }}>
            <Text
              style={{
                color: colors.textSecondary,
                fontSize: 14,
                lineHeight: 22,
              }}
            >
              {body}
            </Text>
          </ScrollView>
          <RsvpPrimaryButton
            title="Close"
            onPress={onClose}
            style={{ marginTop: 20 }}
            testID="close-policy"
          />
        </View>
      </View>
    </Modal>
  );
};

export default RsvpPolicyModal;
